module.exports = __webpack_public_path__ + "static/img/middle.0765d850.png";